import { Progress } from '@components';
import { Box, CircularProgressProps, styled } from '@mui/material';
import { spacing } from '@themes/theme.helpers';

export type DataLoadingProgressProps = Pick<CircularProgressProps, 'size' | 'color'>;

const DataLoaderWrapper = styled(Box)`
  padding: ${spacing(2)};
  width: 100%;
  text-align: center;
`;

export const DataLoadingProgress = ({ size, color }: DataLoadingProgressProps) => {
  return (
    <DataLoaderWrapper>
      <Progress size={size} color={color} />
    </DataLoaderWrapper>
  );
};
